const ENTITIES = {
  company: {
    identity: 'identity',
    name: 'name',
    nameFull: 'nameFull'
  },
  patient: {
    patId: 'patId',
    identity: 'identity',
    birthdate: ['birthdate', 'patientBirthDate'],
    name: 'name',
    patientName: 'name'
  },
  doctor: {
    identity: 'crm',
    name: 'displayName',
    avatar: 'photoURL'
  }
}

function aggregate (entity, payload) {
  if (!payload) return null
  let obj = {}
  obj.id = payload.iuid || payload.uid || payload.id
  const fields = ENTITIES[entity]
  Object.entries(fields).forEach(([fieldKey, fieldValue]) => {
    // Verifica se o valor é um array, se for, verifica se algum dos campos existe
    if (Array.isArray(fieldValue)) {
      for (const field of fieldValue) {
        const value = payload[field]
        if (value) {
          obj[fieldKey] = value
          break
        }
      }
    } else {
      const value = payload[fieldValue]
      if (value) {
        obj[fieldKey] = value
      }
    }
  })
  return obj
}

export { aggregate }



// WEBPACK FOOTER //
// ./src/utils/aggregations.js